export const PRODUCTS = [
  {
    color: 'red',
    line: 'COCO MULTI BALM',
    title: 'ROUGE',
    name: '코코 루즈',
    desc: '촉촉하고 은은한 생기 케어, 립&치크용 스틱밤',
    uri: '/product/ROUGE',
  },
  {
    color: 'pink',
    line: 'COCO MULTI BALM',
    title: 'ROSE',
    name: '코코 로즈',
    desc: '촉촉하고 은은한 생기 케어, 립&치크용 스틱밤',
    uri: '/product/ROSE',
  },
  {
    color: 'green',
    line: 'RORO MULTI BALM',
    title: 'VERT',
    name: '로로 베르',
    desc: '부드럽고 편안한 진정 케어, 페이스&바디용 스틱밤',
    uri: '/product/VERT',
  },
  {
    color: 'blue',
    line: 'RORO MULTI BALM',
    title: 'BLUE',
    name: '로로 블루',
    desc: '수분가득 촉촉한 보습 케어, 페이스&바디용 스틱밤',
    uri: '/product/BLEU',
  },
];
